import React from "react";
import { Key, Calculator } from "react-bootstrap-icons"; // Bootstrap Icons
import { motion } from "framer-motion"; // Animation library
import { Swiper, SwiperSlide } from 'swiper/react'; // Swiper library
import 'swiper/css'; // Import Swiper styles
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';

export default function ServicesSection() {
  const services = [
    {
      icon: <Key className="fs-1" />,
      title: "Rent Property",
      description:
        "Khonike - Real Estate Bootstrap 5 Template best theme for elit, seddo eiusmod tempor dolor sit.",
    },
    {
      icon: <Calculator className="fs-2" />,
      title: "Mortgage Property",
      description:
        "Khonike - Real Estate Bootstrap 5 Template best theme for elit, seddo eiusmod tempor dolor sit.",
    },
    {
      icon: <Key className="fs-1" />,
      title: "Buy Property",
      description:
        "Khonike - Real Estate Bootstrap 5 Template best theme for elit, seddo eiusmod tempor dolor sit.",
    },
    {
      icon: <Calculator className="fs-2" />,
      title: "Sale Property",
      description:
        "Khonike - Real Estate Bootstrap 5 Template best theme for elit, seddo eiusmod tempor dolor sit.",
    },
  ];

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + '</span>';
    },
  };

  return (
    <div className="container my-5">
      <h2 className="text-center mb-5">Our Services</h2>
      <div className="row align-items-center">
        {/* Left Column: Swiper Image Slider */}
        <div className="col-lg-6 mb-3">
          <Swiper
            spaceBetween={50}  // Space between slides
            slidesPerView={1}  // Show one slide at a time
            loop={true}  // Infinite loop
            autoplay={{
              delay: 3000,  // Auto slide interval
              disableOnInteraction: false,
            }}
            pagination={pagination}
            modules={[Pagination]}
          >
            <SwiperSlide>
              <div style={{ position: 'relative' }}>
                <img
                  src="/images/property-4.webp"
                  className="d-block w-100"
                  alt="Property 1"
                  style={{ height: '400px', objectFit: 'cover' }}
                />
                <div
                  className="swiper-caption"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textShadow: '2px 2px 5px rgba(0, 0, 0, 0.7)',
                    zIndex: 10,
                  }}
                >
                  <h5>Modern Architecture</h5>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div style={{ position: 'relative' }}>
                <img
                  src="/images/property-5.webp"
                  className="d-block w-100"
                  alt="Property 2"
                  style={{ height: '400px', objectFit: 'cover' }}
                />
                <div
                  className="swiper-caption"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textShadow: '2px 2px 5px rgba(0, 0, 0, 0.7)',
                    zIndex: 10,
                  }}
                >
                  <h5>Elegant Design</h5>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div style={{ position: 'relative' }}>
                <img
                  src="/images/property-13.webp"
                  className="d-block w-100"
                  alt="Property 3"
                  style={{ height: '400px', objectFit: 'cover' }}
                />
                <div
                  className="swiper-caption"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textShadow: '2px 2px 5px rgba(0, 0, 0, 0.7)',
                    zIndex: 10,
                  }}
                >
                  <h5>Spacious Interiors</h5>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        {/* Right Column: Services */}
        <div className="col-lg-6">
          <div className="row row-cols-1 row-cols-md-2 g-4">
            {services.map((service, index) => (
              <motion.div
                key={index}
                className="col"
                initial={{ opacity: 0, y: 20 }} // Initial state
                animate={{ opacity: 1, y: 0 }} // Final state
                transition={{ duration: 0.6, delay: index * 0.2 }} // Animation timing
              >
                <div className="p-3 rounded shadow-lg">
                  <div className="d-flex align-items-center ">
                    <div className="text-warning me-3">{service.icon}</div>
                    <h5>{service.title}</h5>
                  </div>
                  <p className="text-muted mb-0">{service.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
